export default __webpack_public_path__ + "static/media/rollback.52bf2faa.svg";